<template>
  <div>
    <body>
      <section class="section is-medium">
        <div class="container">
          <div class="columns is-centered is-multiline px-5">
            <div class="column is-half ">
              <h1 v-if="isNewsletter" class="title">Create Newsletter Survey</h1>
              <h1 v-else-if="isWebRating" class="title">Create New Web Rating Widget</h1>
              <h1 v-else class="title">Create Onetime Poll</h1>
              <article
                v-if="$route.query.first && isNewsletter"
                class="message is-info is-light mb-6"
              >
                <div class="message-header">
                  <p>Create Your First Feedback-Gathering Form</p>
                </div>
                <div class="message-body">
<p class="mb-3">Newsletter surveys are the core of getting feedback from your readers. Without a survey, we can&#39;t collect the reader&#39;s feedback. Fear not, you can always edit it later.</p>

<p class="mb-3">Here you&#39;ll define the voting options, customize the reader-facing texts, and more.</p>

<p><strong class="is-size-5">Note:</strong> You need to create one form for each email you send on your newsletter to get the most out of FeedLetter.</p>

                </div>
              </article>
              <p v-else-if="isNewsletter">The intended use is one form per email sent on your newsletter to get the most out of the tool. More in the <router-link :to="{ name: 'Faq'}" >FAQ</router-link>
              </p>
              <p v-else-if="isWebRating">Web Rating widgets gather feedback on your web sites and web apps. Use the default thumb rating or a 5-star with emojis.</p>
              <p v-else>A Onetime Poll is for asking onetime questions in your newsletter or on your website using the embed widgets. Supports questions with up to 5 answers.

Results are not included in the dashboard stats.
              </p>
              <hr />
                <fieldset>
                  <div class="field">
                    <label class="label" for="name"
                      >Form Name (Required - Internal use)</label
                    >
                    <div class="control">
                      <input
                        v-model="feedbackForm.formName"
                        id="formName"
                        name="formName"
                        type="text"
                        placeholder="Give your form a name to find it again."
                        class="input"
                        required
                      />
                    </div>
                  </div>
                  <div v-if="isNewsletter" class="field">

                    <label class="label" for="name">Your Name (Public)</label>
                    <div class="control">
                      <input
                        v-model="feedbackForm.name"
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your name that can be used in a placeholder on the extended feedback page"
                        class="input"
                        required
                      />
                    </div>
                    <p class="help">
                      The name you enter will be used on the extended feedback page as the NAME placeholder with the default texts. Enter a name your readers recognize, e.g. 
                      your name or the name of your newsletter.
                    </p>
                  </div>
                  <div class="field" v-if="isNewsletter">
                    <div class="control">
                      <router-link
                        v-if="!subscribed && limitReached"
                        :to="{ name: 'Upgrade' }"
                        class="button is-primary is-outlined "
                        >Limit Reached. Upgrade Now</router-link
                      >
                      <button
                        v-else
                        :disabled="!saveBtnEnabled"
                        v-bind:class="{ 'is-loading': saving }"
                        class="button is-primary is-outlined "
                        @click.prevent="save"
                      >
                        Create using Defaults
                      </button>

                    </div>
                    <p class="mt-5 notification is-info">
                      Any changes you make here are only valid for this survey. You can set default values in the <router-link to="/account">Account</router-link> section.
                    </p>
                  </div>
                </fieldset>
            </div>
            <div class="column is-12">
              <WebRatingCustomizationSection v-if="isWebRating" :feedbackForm="feedbackForm"
                />
                <FormCustomSection v-else
                  :feedbackForm="feedbackForm"
                />

                <fieldset>
                  <div class="field is-grouped">
                    <div class="control has-text-right is-fullwidth">
                      <router-link
                        v-if="!subscribed && limitReached"
                        :to="{ name: 'Upgrade' }"
                        class="button is-primary is-large"
                        >Limit Reached. Upgrade Now</router-link
                      >
                      <button
                        v-else
                        :disabled="!saveBtnEnabled"
                        v-bind:class="{ 'is-loading': saving }"
                        class="button is-primary "
                        @click.prevent="save"
                      >
                        Create
                      </button>

                    </div>
                  </div>
                </fieldset>
             
            </div>
          </div>
        </div>
      </section>
    </body>
  </div>
</template>

<script>
// @ is an alias to /src
import atomic from "atomicjs";
import FormCustomSection from "@/components/FormCustomizationSection.vue";
import WebRatingCustomizationSection from "@/components/WebRatingCustomizationSection.vue";
import {trackEvent}  from "../lib/flevents"
import { mapState } from 'vuex'

export default {
  name: "FeedbackCreate",
  components: {
    FormCustomSection, WebRatingCustomizationSection
  },
  data: function () {
    return {
      saveBtnEnabled: false,
      loading: false,
      saving: false,
      feedbackForm: {
        formName: null,
        name: null,
        thumbsup: "👍 That helped me. Thanks",
        thumbsok: "😐 Meh - was ok.",
        thumbsdown: "👎 Not interesting to me.",
        thumbsHeadline: "Was it useful? Help us to improve!",
        thumbsParagraph:
          "With your feedback, we can improve the letter. Click on a link to vote:",

        efpThumbsupReasonHeader: "👍 you did enjoy NAME email 👍",
        efpThumbsokReasonHeader:
          "😐 you are not sure what to think about NAME email 😐",
        efpThumbsdownReasonHeader: "👎 you didn’t enjoy NAME email 👎",
        efpThankYouText: "Thank you. Your feedback was successfully shared.",
        efpWhyBoxText: "Why",
        efpWhyBoxPlaceholder: "Listen to your gut :-)",
        efpButtonText: "Send your message",
        efpReaderNamePlaceholder: "Enter your name or leave it blank to stay anonymous",
        efpReaderEmailPlaceholder: "Enter your email if you want a reply from me",
        efpNotificationEmail: null,
        efpNotificationWebhookURL: null,
        efpTextMsgText: "write a text message instead",
        efpVoiceText: "or leave a voice message",
        efpVoiceRemainingText: "Record duration is limited",
        efpAllowAudioFeedback: "1",
        typHeadline: "Thank you for sharing your thoughts",
        typSubHeadline: "We wish you a wonderful day and stay safe!",
        typRedirect: null,
        typShareButtonTwitter: "Share your feedback on Twitter",
        typShareTwitterHandle: null,
        thumbsoption4: null,
        efpThumbsoption4ReasonHeader: null,
        thumbsoption5: null,
        efpThumbsoption5ReasonHeader: null,
        formType: this.$route.meta.formType,
        
        webRatingType: "thumbs",
        wrEnableReviewSchema: "0",
        wrShowBranding: "1",
        showBranding: "1",
        wrShowWidgetTime: "10",
        efpEnabled: "1",
        efpAllowBlankFeedback: "0",
        wrEmailMandatory: "0",
        efpPrefillEmail: "1",
      },
      limitReached: false
    };
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }
    if (this.isNewsletter) {
      console.log("newsletter feedformPresetsLoaded", this.feedformPresetsLoaded)
      if(this.feedformPresetsLoaded) {
        this.setPresets()
      } else {
        setTimeout(this.setPresets, 700)
      }
      trackEvent(this.$store.state.user.id, "survey-create-view-newsletter")
    } else if(this.isWebRating) {
      this.feedbackForm.thumbsHeadline = "How do you like it?"
      this.feedbackForm.efpThumbsupReasonHeader = "What do you love about it?"
      this.feedbackForm.efpThumbsokReasonHeader = "What's missing for you?"
      this.feedbackForm.efpThumbsdownReasonHeader = "What did you hate it?"
      this.feedbackForm.thumbsParagraph = null
      this.feedbackForm.efpThankYouText = null
      this.feedbackForm.efpWhyBoxText = null
      this.feedbackForm.efpReaderNamePlaceholder = null
      if(this.subscribed) {
        this.feedbackForm.efpReaderEmailPlaceholder = "Enter your email if you want a reply"
        this.feedbackForm.efpReaderNamePlaceholder = "Enter your name or stay anonymous"
      } else {
        this.feedbackForm.efpReaderEmailPlaceholder = null
        this.feedbackForm.efpReaderNamePlaceholder = null
      }
      
      this.feedbackForm.efpTextMsgText = null
      this.feedbackForm.efpVoiceText = null
      this.feedbackForm.efpVoiceRemainingText = null
      this.feedbackForm.efpWhyBoxPlaceholder = null
      this.feedbackForm.typSubHeadline = null

      if (this.$route.params.copyFormId !== undefined) {
        this.loadAndPresetCopyForm(this.$route.params.copyFormId);
      }
      trackEvent(this.$store.state.user.id, "survey-create-view-webrating")
    } else {
      this.feedbackForm.efpThumbsupReasonHeader = "👍 you did enjoy"
      this.feedbackForm.efpThumbsokReasonHeader = "😐 you are not sure what to think"
      this.feedbackForm.efpThumbsdownReasonHeader = "👎 you didn’t enjoy"

      this.feedbackForm.thumbsHeadline ="What do you like more?"
      this.feedbackForm.thumbsParagraph=
          "With your feedback, we can improve the letter. Click on a link to vote:"
      this.feedbackForm.thumbsup= "👍 Your voting option 1"
      this.feedbackForm.thumbsok= "😐 Your voting option 2"
      this.feedbackForm.thumbsdown= "👎 Your voting option 3"

      if (this.$route.params.copyFormId !== undefined) {
        this.loadAndPresetCopyForm(this.$route.params.copyFormId);
      }
      trackEvent(this.$store.state.user.id, "survey-create-view-onetimepoll")
    }

    setTimeout(this.delayLimitCheck, 700)

  },
  methods: {
    delayLimitCheck: function () {
      if (!this.account.subscribed) {
        this.checkLimits()
      }
    },
    checkLimits: async function (formId) {
      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.loading = true;
          atomic( self.apiHost + "account/" + self.account.id + "/limits", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },

          })
            .then(function (response) {
              console.log(response)
              if (response.data.count >= response.data.limit ) {
                console.log("limit")
                self.limitReached = true
              }

              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.loading = false;
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    loadAndPresetCopyForm: async function (formId) {
      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.loading = true;
          atomic( self.apiHost + "feedforms/" + formId, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              self.presetFromCopy(self, response);

              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.loading = false;
              self.$buefy.toast.open({
                duration: 7000,
                message: `Sorry but the other survey could not be copied. Please try again later.`,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    presetFromCopy: function (self, response) {
      self.feedbackForm.formType = response.data.form_type;

      if (self.isWebRating) {
        self.feedbackForm.webRatingType = response.data.config.webRatingType
        self.feedbackForm.wrEnableReviewSchema = response.data.config.wrEnableReviewSchema || "0"
        self.feedbackForm.wrShowWidgetTime = response.data.config.wrShowWidgetTime || "10"
        
        self.feedbackForm.wrShowBranding = response.data.config.wrShowBranding || "1"
        self.feedbackForm.wrEmailMandatory = response.data.config.wrEmailMandatory || "0"

        
      }
      
      self.feedbackForm.showBranding = response.data.config.showBranding || "1"
      self.feedbackForm.efpEnabled = response.data.config.efpEnabled || "1"
      self.feedbackForm.efpAllowBlankFeedback = response.data.config.efpAllowBlankFeedback || "0"
      self.feedbackForm.efpPrefillEmail = response.data.config.efpPrefillEmail || "1"
      
      self.feedbackForm.formName = response.data.name + " Copy";
      self.feedbackForm.name = response.data.config.name;
      self.feedbackForm.thumbsup = response.data.config.thumbsupText || response.data.up_label
      self.feedbackForm.thumbsok = response.data.config.thumbsokText || response.data.ok_label
      self.feedbackForm.thumbsdown = response.data.config.thumbsdownText  || response.data.down_label
      self.feedbackForm.thumbsoption4 = response.data.config.thumbsoption4Text  || response.data.option4_label
      self.feedbackForm.thumbsoption5 = response.data.config.thumbsoption5Text  || response.data.option5_label

      if (response.data.config.thumbsHeadline !== undefined) {
        self.feedbackForm.thumbsHeadline = response.data.config.thumbsHeadline;
      }
      if (response.data.config.thumbsParagraph !== undefined) {
        self.feedbackForm.thumbsParagraph = response.data.config.thumbsParagraph;
      }
      if (
        response.data.config.thumbsupReasonHeader !== undefined ||
        response.data.config.efpThumbsupReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsupReasonHeader =
          response.data.config.thumbsupReasonHeader ||
          response.data.config.efpThumbsupReasonHeader;
      } else {
        self.feedbackForm.efpThumbsupReasonHeader = self.feedbackForm.efpThumbsupReasonHeader;
      }
      if (
        response.data.config.thumbsokReasonHeader !== undefined ||
        response.data.config.efpThumbsokReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsokReasonHeader =
          response.data.config.thumbsokReasonHeader ||
          response.data.config.efpThumbsokReasonHeader;
      } else {
        self.feedbackForm.efpThumbsokReasonHeader = self.feedbackForm.efpThumbsokReasonHeader;
      }
      if (
        response.data.config.thumbsdownReasonHeader !== undefined ||
        response.data.config.efpThumbsdownReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsdownReasonHeader =
          response.data.config.thumbsdownReasonHeader ||
          response.data.config.efpThumbsdownReasonHeader;
      } else {
        self.feedbackForm.efpThumbsdownReasonHeader = self.feedbackForm.efpThumbsdownReasonHeader;
      }
      if (
        response.data.config.thumbsoption4ReasonHeader !== undefined ||
        response.data.config.efpThumbsoption4ReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsoption4ReasonHeader =
          response.data.config.thumbsoption4ReasonHeader ||
          response.data.config.efpThumbsoption4ReasonHeader;
      }
      if (
        response.data.config.thumbsoption5ReasonHeader !== undefined ||
        response.data.config.efpThumbsoption5ReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsoption5ReasonHeader =
          response.data.config.thumbsoption5ReasonHeader ||
          response.data.config.efpThumbsoption5ReasonHeader;
      }
      if (response.data.config.efpThankYouText !== undefined) {
        self.feedbackForm.efpThankYouText = response.data.config.efpThankYouText;
      }
      if (response.data.config.efpWhyBoxText !== undefined) {
        self.feedbackForm.efpWhyBoxText = response.data.config.efpWhyBoxText;
      }
      if (response.data.config.efpWhyBoxPlaceholder !== undefined) {
        self.feedbackForm.efpWhyBoxPlaceholder =
          response.data.config.efpWhyBoxPlaceholder;
      }
      if (response.data.config.efpButtonText !== undefined) {
        self.feedbackForm.efpButtonText = response.data.config.efpButtonText;
      }
      if (response.data.config.efpReaderNamePlaceholder !== undefined) {
        self.feedbackForm.efpReaderNamePlaceholder = response.data.config.efpReaderNamePlaceholder;
      }
      if (response.data.config.efpReaderEmailPlaceholder !== undefined) {
        self.feedbackForm.efpReaderEmailPlaceholder = response.data.config.efpReaderEmailPlaceholder
      }
      if (response.data.config.efpTextMsgText !== undefined) {
        self.feedbackForm.efpTextMsgText = response.data.config.efpTextMsgText;
      }

      if (response.data.config.efpVoiceText !== undefined) {
        self.feedbackForm.efpVoiceText = response.data.config.efpVoiceText;
      }

      if (response.data.config.efpAllowAudioFeedback !== undefined) {
        self.feedbackForm.efpAllowAudioFeedback = response.data.config.efpAllowAudioFeedback;
      }

      if (response.data.config.efpVoiceRemainingText !== undefined) {
        self.feedbackForm.efpVoiceRemainingText = response.data.config.efpVoiceRemainingText;
      }

      if (response.data.config.efpNotificationEmail !== undefined) {
        self.feedbackForm.efpNotificationEmail = response.data.config.efpNotificationEmail;
      }
      if (response.data.config.efpNotificationWebhookURL !== undefined) {
        self.feedbackForm.efpNotificationWebhookURL = response.data.config.efpNotificationWebhookURL;
      }
      
      if (response.data.config.typHeadline !== undefined) {
        self.feedbackForm.typHeadline = response.data.config.typHeadline;
      }
      if (response.data.config.typSubHeadline !== undefined) {
        self.feedbackForm.typSubHeadline = response.data.config.typSubHeadline;
      }
      if (response.data.config.typRedirect !== undefined) {
        self.feedbackForm.typRedirect = response.data.config.typRedirect;
      }
      if (response.data.config.typShareTwitterHandle !== undefined) {
        self.feedbackForm.typShareTwitterHandle = response.data.config.typShareTwitterHandle;
      }
      if (response.data.config.typShareButtonTwitter !== undefined) {
        self.feedbackForm.typShareButtonTwitter = response.data.config.typShareButtonTwitter;
      }
    },
    setPresets: function () {
      if (this.feedformPresets.presetName !== undefined) {
        //console.log("set preset", this.feedformPresets.presetName)
        this.feedbackForm.name = this.feedformPresets.presetName;
      }
      if (this.feedformPresets.presetThumbsupText !== undefined) {
        this.feedbackForm.thumbsup = this.feedformPresets.presetThumbsupText;
      }
      if (this.feedformPresets.presetThumbsokText !== undefined) {
        this.feedbackForm.thumbsok = this.feedformPresets.presetThumbsokText;
      }
      if (this.feedformPresets.presetThumbsdownText !== undefined) {
        this.feedbackForm.thumbsdown = this.feedformPresets.presetThumbsdownText;
      }

      /*
      if (this.feedformPresets.presetThumbsoption4Text !== undefined) {
        this.feedbackForm.thumbsoption4 = this.feedformPresets.presetThumbsoption4Text;
      }
      if (this.feedformPresets.presetEfpThumbsoption4ReasonHeader !== undefined) {
        this.feedbackForm.efpThumbsoption4ReasonHeader = this.feedformPresets.presetEfpThumbsoption4ReasonHeader;
      }
      if (this.feedformPresets.presetThumbsoption5Text !== undefined) {
        this.feedbackForm.thumbsoption5 = this.feedformPresets.presetThumbsoption5Text;
      }
      if (this.feedformPresets.presetEfpThumbsoption5ReasonHeader !== undefined) {
        this.feedbackForm.efpThumbsoption5ReasonHeader = this.feedformPresets.presetEfpThumbsoption5ReasonHeader;
      }
      */
      if (this.feedformPresets.presetThumbsHeadline !== undefined) {
        this.feedbackForm.thumbsHeadline = this.feedformPresets.presetThumbsHeadline;
      }
      if (this.feedformPresets.presetThumbsParagraph !== undefined) {
        this.feedbackForm.thumbsParagraph = this.feedformPresets.presetThumbsParagraph;
      }

      if (this.feedformPresets.presetEfpThankYouText !== undefined) {
        this.feedbackForm.efpThankYouText = this.feedformPresets.presetEfpThankYouText;
      }
      if (this.feedformPresets.presetEfpWhyBoxText !== undefined) {
        this.feedbackForm.efpWhyBoxText = this.feedformPresets.presetEfpWhyBoxText;
      }
      if (
        this.feedformPresets.presetEfpWhyBoxPlaceholder !== undefined
      ) {
        this.feedbackForm.efpWhyBoxPlaceholder = this.feedformPresets.presetEfpWhyBoxPlaceholder;
      }
      if (this.feedformPresets.presetEfpButtonText !== undefined) {
        this.feedbackForm.efpButtonText = this.feedformPresets.presetEfpButtonText;
      }
      if (this.feedformPresets.presetEfpReaderNamePlaceholder !== undefined) {
        this.feedbackForm.efpReaderNamePlaceholder = this.feedformPresets.presetEfpReaderNamePlaceholder;
      }
      if (this.feedformPresets.presetEfpReaderEmailPlaceholder !== undefined) {
        this.feedbackForm.efpReaderEmailPlaceholder = this.feedformPresets.presetEfpReaderEmailPlaceholder;
      }
      if (this.feedformPresets.presetEfpTextMsgText !== undefined) {
        this.feedbackForm.efpTextMsgText = this.feedformPresets.presetEfpTextMsgText;
      }

      if (this.feedformPresets.presetEfpVoiceText !== undefined) {
        this.feedbackForm.efpVoiceText = this.feedformPresets.presetEfpVoiceText;
      }
      if (this.feedformPresets.presetEfpAllowAudioFeedback !== undefined) {
        this.feedbackForm.efpAllowAudioFeedback = this.feedformPresets.presetEfpAllowAudioFeedback;
      }

      if (this.feedformPresets.presetEfpVoiceRemainingText !== undefined) {
        this.feedbackForm.efpVoiceRemainingText = this.feedformPresets.presetEfpVoiceRemainingText;
      }
      
      if (
        this.feedformPresets.presetEfpThumbsupReasonHeader !==
        undefined
      ) {
        this.feedbackForm.efpThumbsupReasonHeader = this.feedformPresets.presetEfpThumbsupReasonHeader;
      }
      if (
        this.feedformPresets.presetEfpThumbsokReasonHeader !==
        undefined
      ) {
        this.feedbackForm.efpThumbsokReasonHeader = this.feedformPresets.presetEfpThumbsokReasonHeader;
      }
      if (
        this.feedformPresets.presetEfpThumbsdownReasonHeader !==
        undefined
      ) {
        this.feedbackForm.efpThumbsdownReasonHeader = this.feedformPresets.presetEfpThumbsdownReasonHeader;
      }
      if (this.feedformPresets.presetTypHeadline !== undefined) {
        this.feedbackForm.typHeadline = this.feedformPresets.presetTypHeadline;
      }
      if (this.feedformPresets.presetTypSubHeadline !== undefined) {
        this.feedbackForm.typSubHeadline = this.feedformPresets.presetTypSubHeadline;
      }
      if (this.feedformPresets.presetTypRedirect !== undefined) {
        this.feedbackForm.typRedirect = this.feedformPresets.presetTypRedirect;
      }
      if (this.feedformPresets.presetTypShareTwitterHandle !== undefined) {
        this.feedbackForm.typShareTwitterHandle = this.feedformPresets.presetTypShareTwitterHandle;
      }
      if (this.feedformPresets.presetTypShareButtonTwitter !== undefined) {
        this.feedbackForm.typShareButtonTwitter = this.feedformPresets.presetTypShareButtonTwitter
      }
      if (this.feedformPresets.presetEfpNotificationEmail !== undefined) {
        this.feedbackForm.efpNotificationEmail = this.feedformPresets.presetEfpNotificationEmail;
      }
      if (this.feedformPresets.presetEfpNotificationWebhookURL !== undefined) {
        this.feedbackForm.efpNotificationWebhookURL = this.feedformPresets.presetEfpNotificationWebhookURL
      }
      
      if (this.feedformPresets.presetShowBranding !== undefined) {
        this.feedbackForm.showBranding = this.feedformPresets.presetShowBranding;
      }
      if (this.feedformPresets.presetEfpEnabled !== undefined) {
        this.feedbackForm.efpEnabled = this.feedformPresets.presetEfpEnabled;
      }
      if (this.feedformPresets.presetEfpAllowBlankFeedback !== undefined) {
        this.feedbackForm.efpAllowBlankFeedback = this.feedformPresets.presetEfpAllowBlankFeedback;
      }
      if (this.feedformPresets.presetEfpPrefillEmail !== undefined) {
        this.feedbackForm.efpPrefillEmail = this.feedformPresets.presetEfpPrefillEmail;
      }
    },
    save: async function () {
      trackEvent(this.$store.state.user.id, "survey-create-save")
      var feedbackFormSend = {
        account_id: this.account.id,
        name: this.feedbackForm.formName,
        form_type: this.feedbackForm.formType,
        up_label: this.feedbackForm.thumbsup,
        ok_label: this.feedbackForm.thumbsok,
        down_label: this.feedbackForm.thumbsdown,
        option4_label: this.isEmptyOrSpaces(this.feedbackForm.thumbsoption4) ? null : this.feedbackForm.thumbsoption4,
        option5_label: this.isEmptyOrSpaces(this.feedbackForm.thumbsoption5) ? null : this.feedbackForm.thumbsoption5,
      };
      if (this.isWebRating) {
      feedbackFormSend.config = {
          thumbsHeadline: this.feedbackForm.thumbsHeadline,
          efpThumbsupReasonHeader: this.feedbackForm.efpThumbsupReasonHeader,
          efpThumbsokReasonHeader: this.feedbackForm.efpThumbsokReasonHeader,
          efpThumbsdownReasonHeader: this.feedbackForm.efpThumbsdownReasonHeader,
          efpThumbsoption4ReasonHeader: this.feedbackForm.efpThumbsoption4ReasonHeader,
          efpThumbsoption5ReasonHeader: this.feedbackForm.efpThumbsoption5ReasonHeader,

          efpReaderEmailPlaceholder: this.feedbackForm.efpReaderEmailPlaceholder,
          efpReaderNamePlaceholder: this.feedbackForm.efpReaderNamePlaceholder,
          efpButtonText: this.feedbackForm.efpButtonText,
          typHeadline: this.feedbackForm.typHeadline,
          wrEnableReviewSchema: this.feedbackForm.wrEnableReviewSchema,
          wrShowWidgetTime: this.feedbackForm.wrShowWidgetTime,
          wrShowBranding: this.feedbackForm.wrShowBranding,
          wrEmailMandatory: this.feedbackForm.wrEmailMandatory,
          user_id: this.$parent.user.id,

          efpNotificationEmail: this.feedbackForm.efpNotificationEmail,
          efpNotificationWebhookURL: this.feedbackForm.efpNotificationWebhookURL,
          

          webRatingType: this.feedbackForm.webRatingType
        }
      } else {
        let tmpName = this.feedbackForm.name
        if(tmpName == null || tmpName === "") {
          tmpName = "this"
        } else {
          tmpName = tmpName + "'s"
        }

      feedbackFormSend.config = {
          name: this.feedbackForm.name,
          thumbsHeadline: this.feedbackForm.thumbsHeadline,
          thumbsParagraph: this.feedbackForm.thumbsParagraph,
          efpThumbsoption4ReasonHeader: this.feedbackForm.efpThumbsoption4ReasonHeader,
          efpThumbsoption5ReasonHeader: this.feedbackForm.efpThumbsoption5ReasonHeader,

          efpThankYouText: this.feedbackForm.efpThankYouText,
          efpWhyBoxText: this.feedbackForm.efpWhyBoxText,
          efpWhyBoxPlaceholder: this.feedbackForm.efpWhyBoxPlaceholder,
          efpButtonText: this.feedbackForm.efpButtonText,
          typHeadline: this.feedbackForm.typHeadline,
          typSubHeadline: this.feedbackForm.typSubHeadline,
          user_id: this.$parent.user.id,
          efpThumbsupReasonHeader: this.feedbackForm.efpThumbsupReasonHeader,
          efpThumbsokReasonHeader: this.feedbackForm.efpThumbsokReasonHeader,
          efpThumbsdownReasonHeader: this.feedbackForm.efpThumbsdownReasonHeader,

          typRedirect: this.feedbackForm.typRedirect,
          typShareTwitterHandle: this.feedbackForm.typShareTwitterHandle,
          typShareButtonTwitter: this.feedbackForm.typShareButtonTwitter,
          efpNotificationEmail: this.feedbackForm.efpNotificationEmail,
          efpNotificationWebhookURL: this.feedbackForm.efpNotificationWebhookURL,
          efpReaderNamePlaceholder: this.feedbackForm.efpReaderNamePlaceholder,
          efpReaderEmailPlaceholder: this.feedbackForm.efpReaderEmailPlaceholder,

          efpTextMsgText: this.feedbackForm.efpTextMsgText,
          efpVoiceText: this.feedbackForm.efpVoiceText,
          efpAllowAudioFeedback: this.feedbackForm.efpAllowAudioFeedback,
          efpVoiceRemainingText: this.feedbackForm.efpVoiceRemainingText,

          showBranding: this.feedbackForm.showBranding,
          efpEnabled: this.feedbackForm.efpEnabled,
          efpAllowBlankFeedback: this.feedbackForm.efpAllowBlankFeedback,
          efpPrefillEmail: this.feedbackForm.efpPrefillEmail,
        }
      }

      var self = this;
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.saving = true;

          atomic(self.apiHost + "feedforms", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
            data: feedbackFormSend,
          })
            .then(function (response) {
              self.$router.push({
                name: "FeedbackView",
                params: { formId: response.data.id },
                query: { created: "true" },
              });

              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.saving = false;
              self.$buefy.toast.open({
                duration: 7000,
                message: `OMG, saving your survey failed. It was us, not you and the team was already notified. Please try again later.`,
                type: 'is-danger'
              })
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
  },
  computed: {
    formName() {
      return this.feedbackForm.formName;
    },
    subscribed() {
      return this.account.subscribed;
    },
    ...mapState([
      "user",
      "account",
      "feedformPresets",
      "feedformPresetsLoaded"
    ]),
    isNewsletter() {
      return this.$route.meta.formType === "newsletter"
    },
    isOnetimeForm() {
      return this.$route.meta.formType === "onetime"
    },
    isWebRating() {
      return this.$route.meta.formType === "webrating"
    }

  },
  watch: {
    formName: function (val) {
      this.saveBtnEnabled = this.feedformPresetsLoaded && val !== null && val !== "";
    },
    feedformPresetsLoaded: function (val) {
      this.saveBtnEnabled = val && this.formName !== null && this.formName !== "";
    },
  },
};
</script>
